import { PartnersHero } from "components";
import type { PartnersHeroProps } from "components/PartnersHero";
import type { ReactStoryblokComponent } from "types/storyblok";

export const PartnersHeroAdapter = ({
  blok: { content, marginBottom, backgroundImageUrlDesktop, backgroundImageUrlMobile, backgroundImageAlt },
}: ReactStoryblokComponent<PartnersHeroProps>) => (
  <PartnersHero
    backgroundImageAlt={backgroundImageAlt}
    content={content}
    backgroundImageUrlDesktop={backgroundImageUrlDesktop}
    backgroundImageUrlMobile={backgroundImageUrlMobile}
    marginBottom={marginBottom}
  />
);
